/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p-autoComplete[_ngcontent-%COMP%]{border:1px solid #ccc}"];
export { styles as styles };
